export const sxStyle = {
  title: {
    color: 'black',
    fontWeight: 600,
    fontSize: { xs: '14px', sm: '16px' },
  },

  subTitle: {
    color: 'black',
    fontSize: { xs: '14px', sm: '16px' },
  },

  seeLess: theme => ({
    textAlign: 'center',
    lineHeight: 1,
    borderRadius: '8px',
    fontSize: { xs: '12px', sm: '18px' },
    bgcolor: theme.palette.primary.main, // fondo primary dinámico
    color: theme.palette.primary.contrastText || theme.palette.text.colorText1, // texto legible
    textTransform: 'uppercase',
    p: { xs: '8px', sm: '12px' },
    '&:hover': {
      bgcolor: theme.palette.primary.main,
      opacity: 0.9,
    },
  }),
};
